import { createAction, props } from '@ngrx/store';
import { StoreConstants } from '../constants/store-constants';
import { CampaignContent } from '../models/campaign-models';

export const setCampaignContent = createAction(
  `${StoreConstants.STORE_KEY} Set content`,
  props<{ content: CampaignContent }>(),
);

export const getCampaignContent = createAction(
  `${StoreConstants.STORE_KEY} Get content`,
  props<{ content: CampaignContent }>(),
);

export const setCampaignSettings = createAction(
  `${StoreConstants.STORE_KEY} Set settings`,
  props<{ showExternalIdField: boolean }>()
);

export const getCampaignSettings = createAction(
  `${StoreConstants.STORE_KEY} Get settings`,
  props<{ showExternalIdField: boolean }>()
);
